import type { Ref } from 'vue';
import { withCmsMediaSaving } from '@/helpers/cmsMediaSavingUi';

/** Wraps media save + refresh with wait cursor and syncing flag. */
export async function runCmsMediaSync(
  isSyncing: Ref<boolean>,
  task: () => Promise<void>,
): Promise<void> {
  isSyncing.value = true;
  try {
    await withCmsMediaSaving(task);
  } finally {
    isSyncing.value = false;
  }
}
